import(/* webpackMode: "eager" */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft\\src\\app\\(root)\\contact\\contactShow.js");
